(ns app.front.view.group.admin.config.copy-group-config
  (:require [app.domain.fee.model :as fee-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.modal :as modal]
            [app.front.util :as futil]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.i18n :as i18n]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(defn- gc-names [gc]
  (i18n-model/strings-map (:group.config/names gc)))

(defn- gc-names-copy [gc]
  (let [tconfig (<sub [:tconfig])
        trl     #((i18n/tr-query tconfig %) [:group.config/copy])]
    (->> (gc-names gc)
         (map (fn [[lang name]]
                [lang (str name " - " (trl lang))]))
         (into {}))))

(defn copy-tr [{:group.config/keys [level]}]
  (if (= level :group-config.level/category)
    [:group.config/copy-category]
    [:group.config/copy-work-type]))

(rf/reg-event-fx ::copy-group-config.success
  (fn [{:keys [db]} [_ status resp]]
    {:db         (assoc-in db [::configuration :modal-open?] false)
     :dispatch-n [[::entities/apply-changes status resp]
                  [:notifications/add :toast :success :success :group.config/copy-success]]}))

(rf/reg-event-fx ::copy-group-config
  (fn [{:keys [db]} _]
    {:fx [[:comm/command {:command    :group/copy-config
                          :method     :post
                          :data       (-> (::configuration db)
                                          (dissoc :names-edited? :modal-open?)
                                          (update :group-config :db/id)
                                          (p/update-if-contains :parent-category :db/id))
                          :on-success [::copy-group-config.success]}]]}))

(rf/reg-event-db ::open-modal
  (fn [db [_ gc]]
    (assoc db ::configuration
           (cond-> {:modal-open?   true
                    :copy-config?  true
                    :copy-fees?    true
                    :names         (gc-names-copy gc)
                    :names-edited? false
                    :group-config  gc}
             (= (:group.config/level gc) :group-config.level/work-type)
             (assoc :parent-category (:entity/parent gc))))))

(rf/reg-event-db ::set-config
  (fn [db [_ config-key config-value]]
    (assoc-in db [::configuration config-key] config-value)))

(rf/reg-event-db ::edit-names
  (fn [db [_ names]]
    (-> db
        (assoc-in [::configuration :names] names)
        (assoc-in [::configuration :names-edited?] true))))

(rf/reg-event-db ::set-parent-category
  (fn [db [_ category]]
    (let [gc     (-> db ::configuration :group-config)
          parent (or category (-> db ::configuration :group-config :entity/parent))]
      (cond-> (assoc-in db [::configuration :parent-category] parent)
        (-> db ::configuration :names-edited? not)
        (assoc-in [::configuration :names]
                  (if (= parent (:entity/parent gc))
                    (gc-names-copy gc)
                    (gc-names gc)))))))

(rf/reg-sub ::configuration :-> ::configuration)

(rf/reg-sub ::get-config
  :<- [::configuration]
  (fn [config [_ config-key]]
    (get config config-key)))


(defn parent-category-selector [{:keys [categories tr lang]}]
  [:div
   [:label.bx--label (tr [:group.config/parent-category])]
   (cc/combo-box {:id                 "copy-category-destination-select"
                  :placeholder        (-> (<sub [::get-config :parent-category])
                                          :group.config/names
                                          (i18n-model/get-text lang))
                  :on-change          #(>evt [::set-parent-category (futil/oget % :selectedItem)])
                  :item-to-string     #(i18n-model/get-text (:group.config/names %) lang)
                  :should-filter-item (fn [args]
                                        (let [input (futil/oget args :inputValue)
                                              item  (futil/oget args :item)]
                                          (and input
                                               (-> (:group.config/names item)
                                                   (i18n-model/get-text lang)
                                                   str/lower-case
                                                   (str/includes? (str/lower-case input))))))
                  :items              categories})])


(defn copy-fees [{:keys [tr lang group-config]}]
  (let [fee-schedules      (->> group-config
                                :group.config/group
                                fee-model/group-schedules)
        draft-fee-schedule (->> fee-schedules
                                (filter (comp not :fee-schedule/valid-from))
                                first)
        checked?           (boolean (<sub [::get-config :copy-fees?]))
        [enabled? info]    (cond
                             (empty? fee-schedules)
                             [false (tr [:group.config/no-fee-schedules])]

                             (not draft-fee-schedule)
                             [false [:<>
                                     (tr [:group.config/no-draft-fee-schedules])
                                     [:br]
                                     [:a {:href (href/href :view/group.admin.fees {:group-id (->> group-config :group.config/group :db/id)})}
                                      (tr [:group.config/go-to-fees])]]]

                             :else
                             [true (when checked?
                                     (tr [:group.config/target-fee-schedule] [(or (some-> draft-fee-schedule :fee-schedule/titles (i18n-model/get-text lang))
                                                                                  (tr [:fees/untitled-fee-schedule]))]))])]
    (when (and (not enabled?) checked?)
      (>evt [::set-config :copy-fees? false]))
    [:<>
     [cc/checkbox {:id         "copy-category-copy-fees"
                   :label-text (tr [:group.config/copy-fees?])
                   :disabled   (not enabled?)
                   :checked    checked?
                   :on-change  #(>evt [::set-config :copy-fees? %])}]
     info]))


(defn copy-gc-modal []
  (let [lang         (<sub [:language])
        tr           (<sub [:tr])
        open?        (<sub [::get-config :modal-open?])
        group-config (<sub [::get-config :group-config])
        level        (:group.config/level group-config)
        categories   (when (= level :group-config.level/work-type)
                       (->> group-config
                            :entity/parent
                            :entity/parent
                            :entity/_parent
                            (sort-by #(-> % :group.config/names (i18n-model/get-text lang)))))]
    [modal/composed-input-modal {:on-close #(>evt [::set-config :modal-open? false])
                                 :open     open?}
     [cc/modal-header {:close-modal #(>evt [::set-config :modal-open? false])
                       :title       (str (tr (copy-tr group-config))
                                         " - "
                                         (i18n-model/get-text-from-entities-or-map
                                           (:group.config/names group-config)
                                           lang))}]
     [cc/modal-body
      {}
      [:div {:style {:height "265px"}}
       (when categories
         [parent-category-selector (util/mmap tr lang categories)])
       [:div.mt-2
        [ui-i18n/edit-language-selector {:allowed-locales-sub ::gas/allowed-locales
                                         :class               "float-left"}]
        [ui-i18n/localized-string-edit {:strings             (<sub [::get-config :names])
                                        :label-text          (tr [:group.config/name])
                                        :on-change           #(rf/dispatch-sync [::edit-names %])
                                        :allowed-locales-sub ::gas/allowed-locales}]]
       [:div.mt-4
        (tr [:group.config/copy-options])
        [cc/checkbox {:id         "copy-category-copy-config"
                      :label-text (tr [:group.config/copy-config?])
                      :checked    (boolean (<sub [::get-config :copy-config?]))
                      :on-change  #(>evt [::set-config :copy-config? %])}]
        (when (<sub [::gas/has-feature? :group.feature/fees-and-payments])
          [copy-fees (util/mmap group-config tr lang)])]]]
     [cc/modal-footer
      {}
      (cc/button {:kind     :secondary
                  :on-click #(>evt [::set-config :modal-open? false])}
                 (tr [:close]))
      (ui/button {:kind     :primary
                  :on-click #(>evt [::copy-group-config])}
                 (tr [:group.config/copy]))]]))

(defn copy-gc-button [tr gc]
  (ui/button {:size     :small
              :kind     :tertiary
              :icon     i/copy
              :on-click #(do (>evt [::open-modal gc])
                             (.stopPropagation %))}
             (tr (copy-tr gc))))
